import React from 'react';
function HelpCircle({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
      <path d="M12.5 16a.5.5 0 10-1 0 .5.5 0 001 0z" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 9.003a3.02 3.02 0 011.348-1.59 3.166 3.166 0 012.086-.37 3.11 3.11 0 011.84 1.024c.47.542.727 1.227.726 1.935C15 12.001 11.912 13 11.912 13"
      />
    </svg>
  );
}

export default HelpCircle;
